import { useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type SemanticSearchResult } from '../../api/analytics';

export function SemanticSearchPage() {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState<SemanticSearchResult | null>(null);
  const [error, setError] = useState('');

  const search = async () => {
    if (!query.trim()) return;
    setError('');
    try {
      setResult(await analyticsApi.biSemanticSearch(query));
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Semantic Search</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      <div className="mt-4 flex gap-2">
        <input value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && search()} placeholder="Search metrics, KPIs, reports..." className="flex-1 rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        <button onClick={search} className="rounded-lg bg-brand-600 px-4 py-2 text-sm text-white hover:bg-brand-700">Search</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {result && (
        <div className="mt-6 space-y-4">
          <h2 className="font-medium">Metrics matching &quot;{result.query}&quot;</h2>
          {result.metrics.map((m) => (
            <div key={m.key} className="rounded-lg border p-3 dark:border-slate-700">
              <p className="font-medium">{m.name}</p>
              <p className="text-xs text-slate-500">{m.domain} · {m.key}</p>
              {m.description && <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{m.description}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
